import type React from 'react'

interface ConditionalWrapperProps {
  condition: boolean
  children: React.ReactNode
  trueWrapper: React.FC
  falseWrapper: React.FC
}

/**
 *
 * @example
 * // The following example will conditionally render the child div in a Horizontal if the breakpoint is xl, otherwise it will render in a Vertical
 *
 * <ConditionalWrapper
 *    condition={breakpoint === "xl"}
 *    trueWrapper={Horizontal}
 *    falseWrapper={Vertical}
 * >
 *    <div>Content</div>
 * </ConditionalWrapper>
 */
export function ConditionalWrapper(props: ConditionalWrapperProps) {
  const trueWrapper = props.trueWrapper ?? ((props) => <>{props.children}</>)
  const falseWrapper = props.falseWrapper ?? ((props) => <>{props.children}</>)
  if (props.condition) return trueWrapper({ children: props.children })
  else return falseWrapper({ children: props.children })
}

ConditionalWrapper
